<template>
  <div class="camera-image-preview">
    <!-- <span class="image-title">{{description}}</span> -->
    <!-- <div @click.stop="clickDelegate">

    </div> -->
    <label class="file-select">
      <div
        class="select-button"
        v-show="!imgSrc"
      >
        ADICIONAR FOTO
      </div>

      <md-spinner md-indeterminate v-if="isLoading && imgSrc"></md-spinner>
      <img
        v-show="imgSrc"
        :src="imgSrc"
        @load="revokeURL"
      />
      <input
        type="file"
        :value="inputfile"
        @change="handleFileChange"
        accept="image/*"
      />
    </label>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
// import ImageCompressor from '@xkeshi/image-compressor'
import pica from './../../node_modules/pica/dist/pica.min'
const resizer = pica()
export default {
  name: 'camera-image-select',
  props: {
    description: String,
    photoId: Number,
    imageId: { type: String, required: false },
    imageUrl: String
  },
  data: () => ({
    imgSrc: '',
    // imgBlob: null
    inputfile: '',
    isLoading: true
  }),
  beforeMount () {
    this.inputfile = ''
    if (this.imageId) {
      this.FETCH_IMAGE(this.imageId).then(imgBlob => {
        this.loadImage(imgBlob)
      }).catch((e) => {
        console.log('imagem not found')
        if (this.imageUrl) {
          this.imgSrc = this.imageUrl
        }
      })
    } else {
      if (this.imageUrl) {
        this.imgSrc = this.imageUrl
      } else {
        this.imgSrc = ''
      }
    }
  },
  methods: {
    ...mapActions([
      'ADD_IMAGE',
      'SET_IMAGE',
      'FETCH_IMAGE'
    ]),
    handleFileChange (e) {
      let vm = this
      if (e.target.files && e.target.files[0]) {
        let img = new Image()
        img.onload = () => {
          // To scale image we calculate new width and height, resize image by height and crop by width
          let scaledHeight, scaledWidth

          scaledHeight = 600
          scaledWidth = Math.floor(img.width * scaledHeight / img.height)

          let quality = 0 // (ext === 'jpeg' || ext === 'jpg') ? resizeConfig.jpeg_quality : undefined;

          let width = Math.min(img.height * scaledWidth / scaledHeight, img.width)
          let cropX = (width - img.width) / 2

          let source = document.createElement('canvas')
          let dest = document.createElement('canvas')

          source.width = width
          source.height = img.height

          dest.width = scaledWidth
          dest.height = scaledHeight

          source.getContext('2d').drawImage(img, cropX, 0, width, img.height)

          resizer.resize(source, dest, { quality: 0, alpha: false, unsharpAmount: 50 })
            .then(() => resizer.toBlob(dest, e.target.files[0], quality))
            .then(function (blob) {
              window.URL.revokeObjectURL(img.src)
              if (!vm.imageId) {
                vm.ADD_IMAGE(blob).then(imgId => {
                  vm.isLoading = false
                  vm.imgSrc = window.URL.createObjectURL(blob)
                  vm.$emit('add', imgId, vm.photoId, vm.imgSrc)
                })
              } else {
                vm.SET_IMAGE({ id: vm.imageId, image: blob }).then(() => {
                  vm.isLoading = false
                  vm.imgSrc = window.URL.createObjectURL(blob)
                  vm.$emit('add', vm.imageId, vm.photoId, vm.imgSrc)
                })
              }
              // vm.imgBlob = blob
              // vm.previewSrc = window.URL.createObjectURL(blob)
            })
        }
        img.src = window.URL.createObjectURL(e.target.files[0])
        // let compressor = new ImageCompressor()
        // compressor.compress(e.target.files[0], { quality: 0.6, convertSize: 1000000 }).then(result => {
        //   this.ADD_IMAGE(result).then(imgId => {
        //     vm.loadImage(result)
        //     vm.$emit('add', imgId, vm.photoId)
        //   })
        // })
      }
    },
    revokeURL () {
      console.log('Image loaded')
      this.isLoading = false
      // URL.revokeObjectURL(this.imgSrc)
    },
    loadImage (blob) {
      console.log('loading image')
      this.imgSrc = URL.createObjectURL(blob)
      // var fileReader = new FileReader()
      // fileReader.onload = function (e) {
      //   this.imgSrc = e.target.result
      // }.bind(this)
      // fileReader.readAsDataURL(blob)
    },
    clickDelegate () {
      this.$emit('select', this.imageId, this.photoId)
    },
    remove () {
      this.inputfile = ''
      this.imgSrc = ''
    }
  }
}
</script>
<style scoped>
/* .camera-image-preview {
  max-width: 50px;
  max-height: 70px;
  margin: 5px;
} */

.image-title {
  text-align: center;
  height: 20px;
  overflow: hidden;
  width: "100%";
  display: block;
}

.file-select > .select-button {
  color: white;
  background-color: green;
  text-align: center;
  padding-top: 15px;
  width: 100%;
  height: 50px;
}

.file-select > input[type="file"] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// CameraImageSelect.vue?42213f04